import {
  RecurringDirection,
  RecurringSourceKind,
  type AccountWithBuckets,
  type AppCurrency,
  type UpcomingRecurring,
} from '@financial/shared';
import { accountAvailableBalance } from './balancePreview';

export interface RecurringFundingIssue {
  recurringExpenseId: string;
  name: string;
  amount: number;
  currency: AppCurrency;
  accountId: string;
  accountName: string;
  availableBalance: number;
  shortfall: number;
}

function roundMoney(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

/**
 * Detecta reglas que ya corresponden y que, con el saldo libre actual, el
 * servidor rechazaría. Los apartados se excluyen porque no financian cargos ni
 * traspasos que salen del saldo disponible.
 */
export function recurringFundingIssues(
  upcoming: UpcomingRecurring[],
  accounts: AccountWithBuckets[],
): RecurringFundingIssue[] {
  const accountsById = new Map(accounts.map((account) => [account.id, account]));

  return upcoming.flatMap((item) => {
    if (
      item.daysUntil > 0 ||
      item.sourceKind !== RecurringSourceKind.ACCOUNT ||
      item.direction === RecurringDirection.INCOME
    ) {
      return [];
    }

    const account = accountsById.get(item.sourceId);
    if (!account || account.currency !== item.currency) return [];

    const availableBalance = Math.max(0, roundMoney(accountAvailableBalance(account)));
    if (item.amount <= availableBalance + 0.005) return [];

    return [
      {
        recurringExpenseId: item.id,
        name: item.name,
        amount: item.amount,
        currency: item.currency,
        accountId: account.id,
        accountName: account.name,
        availableBalance,
        shortfall: roundMoney(item.amount - availableBalance),
      },
    ];
  });
}
